import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import { AuthContext } from '../../context/AuthContext';
import { TipoTerceiroContext } from '../../context/TipoTerceiro';
import { TipoTerceiroType, CreateTipoTerceiroType, UpdateTipoTerceiroType } from '../../context/hooks/useTipoTerceiro';
import useUser from '../../context/hooks/useUser';

import { CreateTipoTerceiroModal } from '../../components/TipoTerceiro/CreateTipoTerceiroModal';
import { EditTipoTerceiroModal } from '../../components/TipoTerceiro/EditTipoTerceiroModal';

const TipoTerceiro = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listTipoTerceiro, pageCount, getAllTipoTerceiroPaged, createTipoTerceiro, updateTipoTerceiro, deleteTipoTerceiro } = useContext(TipoTerceiroContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [selectedTipoTerceiroId, setSelectedTipoTerceiroId] = useState(0);
    const [newTipoTerceiro, setNewTipoTerceiro] = useState<CreateTipoTerceiroType>({
        type: '',
        empresaId: objUserTk.EmpresaId,
    });
    const [editingTipoTerceiro, setEditingTipoTerceiro] = useState<UpdateTipoTerceiroType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        type: '',
    });

    useEffect(() => {
        setLoading(true);
        getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar tipos de terceiro:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllTipoTerceiroPaged(value, 9, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            });
    };

    const handleEditTipoTerceiro = (tipoTerceiro: TipoTerceiroType) => {
        setEditingTipoTerceiro(tipoTerceiro);
        setEditModalOpen(true);
    };

    const handleDeleteTipoTerceiro = (tipoTerceiroId: number) => {
        if (window.confirm("Tem certeza que deseja excluir este tipo de terceiro?")) {
            deleteTipoTerceiro(tipoTerceiroId)
                .then(deletedTipoTerceiro => {
                    if (deletedTipoTerceiro) {
                        getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId);
                    } else {
                        console.error("Erro ao excluir tipo de terceiro.");
                    }
                    getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId);
                })
                .catch(error => {
                    console.error("Erro ao excluir tipo de terceiro:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Tipos de Terceiros"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar tipo de usuário
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTipoTerceiro.map((tipoTerceiro: TipoTerceiroType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{tipoTerceiro.type}</td>
                                                <td>
                                                    {userPermissions.includes(3) && (
                                                        <Button onClick={() => { handleEditTipoTerceiro(tipoTerceiro); setSelectedTipoTerceiroId(tipoTerceiro.id); }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {userPermissions.includes(4) && (
                                                        <Button onClick={() => handleDeleteTipoTerceiro(tipoTerceiro.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {pageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={pageCount}
                                        />
                                    </div>
                                )}
                                {listTipoTerceiro.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os tipos de terceiro.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateTipoTerceiroModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId)}
            />

            <EditTipoTerceiroModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                tipoTerceiro={editingTipoTerceiro}
                onUpdated={() => getAllTipoTerceiroPaged(1, 9, objUserTk.EmpresaId)}
            />
        </>
    );
};

export default TipoTerceiro;